import React, { useContext } from 'react';

import { GlobalEventListenerContext } from 'ui-components/components/global-event-listener/context';

import { Connected } from './connected';

export const ScanToVerifyBodyWrapped = (props) => {
  const { focus } = useContext(GlobalEventListenerContext);
  return <Connected {...props} focusGlobalEventListenerRoot={focus} />;
};
